/**IMPORTANT LIBRARY IMPORT */
import React from "react";
import PageHero from "../Components/PageHero";




const About=()=>{
 

    return(
        <>
        {/**HERO SECTION */}
        <PageHero heading={"About Us"}/>

        </>
    )
}

export default About;